import { postAppGraphql } from "./appGraphqlService";

export type SchoolOption = {
  id: string;
  name: string;
  district_id: string;
  district_state_id: string;
};

export type FetchSchoolsParams = {
  districtIds: string[];
  gradeIds?: string[];
  stateIds?: string[];
};

const SCHOOLS_FILTER_QUERY = `
  query SchoolsFilter(
    $stateIDs: [String!]
    $districtIDs: [String!]
    $gradeIDs: [String!]
  ) {
    schoolsFilterList(
      state_ids: $stateIDs
      district_ids: $districtIDs
      grade_ids: $gradeIDs
    ) {
      id
      name
      district_id
      district_state_id
    }
  }
`;

type SchoolsFilterResponse = {
  schoolsFilterList?: SchoolOption[];
};

function normalizeIdList(ids: string[] | undefined): string[] | undefined {
  const normalized = ids?.map((id) => id.trim()).filter(Boolean) ?? [];
  return normalized.length ? normalized : undefined;
}

export async function fetchSchools(
  token: string,
  { districtIds, gradeIds, stateIds }: FetchSchoolsParams,
): Promise<SchoolOption[]> {
  const normalizedDistrictIds = normalizeIdList(districtIds);
  if (!normalizedDistrictIds?.length) {
    return [];
  }

  const payload = await postAppGraphql<SchoolsFilterResponse>({
    token,
    operationName: "SchoolsFilter",
    query: SCHOOLS_FILTER_QUERY,
    variables: {
      districtIDs: normalizedDistrictIds,
      ...(normalizeIdList(gradeIds)
        ? { gradeIDs: normalizeIdList(gradeIds) }
        : {}),
      ...(normalizeIdList(stateIds)
        ? { stateIDs: normalizeIdList(stateIds) }
        : {}),
    },
  });

  return payload.data?.schoolsFilterList ?? [];
}
